module.exports = __webpack_public_path__ + "img/loadingavatars.64df6c7.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/loading/imgs/loadingavatars.gif
// module id = ./assets/loading/imgs/loadingavatars.gif
// module chunks = 2 3 4 5 6 7 8